import { render, staticRenderFns } from "./ContentCarousel.vue?vue&type=template&id=be0a4220&"
import script from "./ContentCarousel.vue?vue&type=script&lang=js&"
export * from "./ContentCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ContentCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports